/**
 * @generated SignedSource<<ad3a03e40cca9b864a934fdceeaadd07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type MilestoneState = "CLOSED" | "OPEN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type RepositoryMilestoneIndexPageContentInternal$data = {
  readonly closed: {
    readonly totalCount: number;
  } | null | undefined;
  readonly id: string;
  readonly milestones: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly closed: boolean;
        readonly closedIssueCount: number;
        readonly description: string | null | undefined;
        readonly dueOn: string | null | undefined;
        readonly id: string;
        readonly openIssueCount: number;
        readonly progressPercentage: number;
        readonly repository: {
          readonly id: string;
          readonly viewerCanPush: boolean;
        };
        readonly state: MilestoneState;
        readonly title: string;
        readonly url: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly totalCount: number;
  } | null | undefined;
  readonly nameWithOwner: string;
  readonly open: {
    readonly totalCount: number;
  } | null | undefined;
  readonly viewerCanPush: boolean;
  readonly " $fragmentType": "RepositoryMilestoneIndexPageContentInternal";
};
export type RepositoryMilestoneIndexPageContentInternal$key = {
  readonly " $data"?: RepositoryMilestoneIndexPageContentInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryMilestoneIndexPageContentInternal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanPush",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v4 = [
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": "DESC",
      "kind": "LocalArgument",
      "name": "orderDirection"
    },
    {
      "defaultValue": "CREATED_AT",
      "kind": "LocalArgument",
      "name": "orderField"
    },
    {
      "defaultValue": 0,
      "kind": "LocalArgument",
      "name": "skip"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "state"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryMilestoneIndexPageContentInternal",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "direction",
              "variableName": "orderDirection"
            },
            {
              "kind": "Variable",
              "name": "field",
              "variableName": "orderField"
            }
          ],
          "kind": "ObjectValue",
          "name": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "skip",
          "variableName": "skip"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "states.0",
              "variableName": "state"
            }
          ],
          "kind": "ListValue",
          "name": "states"
        }
      ],
      "concreteType": "MilestoneConnection",
      "kind": "LinkedField",
      "name": "milestones",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MilestoneEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Milestone",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "closed",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "closedIssueCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dueOn",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "openIssueCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "progressPercentage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Repository",
                  "kind": "LinkedField",
                  "name": "repository",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "open",
      "args": [
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "states",
          "value": "OPEN"
        }
      ],
      "concreteType": "MilestoneConnection",
      "kind": "LinkedField",
      "name": "milestones",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": "milestones(first:0,states:\"OPEN\")"
    },
    {
      "alias": "closed",
      "args": [
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "states",
          "value": "CLOSED"
        }
      ],
      "concreteType": "MilestoneConnection",
      "kind": "LinkedField",
      "name": "milestones",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": "milestones(first:0,states:\"CLOSED\")"
    }
  ],
  "type": "Repository",
  "abstractKey": null
};
})();

(node as any).hash = "6e463c53cb4029f458e12eb1d3f08a53";

export default node;
